export const Logo = ({ size = 48 }) => (
  <img
    src="/photos/logo.png"
    alt="Bar Incontro — logo ufficiale"
    data-testid="bar-incontro-logo-img"
    width={size}
    height={size}
    style={{ width: size, height: size }}
    className="rounded-xl border border-sand/15 object-cover"
  />
);
